import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /cities/* children (city detail pages) render through here.
// The city list itself lives at ./cities/index.tsx ("/cities/").
export const Route = createFileRoute("/cities")({
  component: () => <Outlet />,
});
